import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';
import { PagingTable,ConfirmBox,Loading } from 'component-lib';
import { RoleConfiguration } from 'utils-lib';
import { AccountsModel, RequestAjaxClass } from 'models-lib';

class Accounts extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Limit = 10;
        this.state.Start = 0;

        this.AccountsModel = new AccountsModel([this]);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentWillMount(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
            ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        this.AccountsModel.SetRequest(this.Request);
    }

    componentDidMount()
    {
        this.didMount();
    }

    componentDidUpdate(){
        this.didMount();
    }

    Update(observer){
        let me = this;
        this.setState({},()=>{
            if(observer === "Accounts"){
                let accounts = [];
                this.AccountsModel.Accounts.forEach(function(value) {
                    let account = {};
                    account.Id = value.Id;
                    account.IdCustomer =  value.IdCustomer;
                    account.Email = value.Email;
                    account.Name = value.Name;
                    accounts.push(account);
                });
                
                me.refs.table.setState({ Data: accounts, Count: this.AccountsModel.Count, Limit: this.AccountsModel.Limit, Start: this.AccountsModel.Start, End: this.AccountsModel.Start+accounts.length });
                ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            }
            else if (observer === "DeleteAccounts"){
                me.load(me.refs.table.PrepareSendData());
                ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            }
        })
    }
    
    load(sendData){
        this.AccountsModel.GetAccounts(sendData);
    }

    didMount(){
       $("#HeaderTitle").html(Vas.Resources.Labels["Accounts"]);
    }

    Delete(id){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        //Löschen eines Accounts
        let user = {};
        user.userId = id;

        this.AccountsModel.DeleteAccount(id);
    }

    render(){
        let rights = RoleConfiguration.getRoleConfig();
        let right = '';
        if (rights[4]){
            right = rights[4];
        }

        return (
          <div 
            className={"form"} 
            style={{ width: '560px' }}>
            <br />
            <PagingTable 
            ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error)}}
              ref="table" 
              TableReference={this} 
              DataBaseTable={"F2Users"}
              Border={true} 
              Selectable={false} 
              Delete={true} 
              DeleteOnClick={(event)=>{
                  let id = $(event.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id; 
                  ReactDOM.render(<ConfirmBox 
                    AppURL={Vas.ApplicationUrl} 
                    LabelConfirm={Vas.Resources.Labels["Confirm"]}
                    LabelCancel={Vas.Resources.Labels["Cancel"]} 
                    modal={true} 
                    MessageText={Vas.Resources.Labels["ConfirmDeleteAccount"]} 
                    Click={()=>{this.Delete(id);}} /> , document.getElementById('messageContainer'));}}
              Limit={this.state.Limit} 
              Start={this.state.Start} 
              End={this.state.End} 
              Count={this.state.Count} 
              Columns={[Vas.Resources.Labels["Email"],Vas.Resources.Labels["Name"],Vas.Resources.Labels["Action"]]} 
              Keys={["Email","Name"]} 
              Data={this.state.Data}
              Right={right}
              AppURL={Vas.ApplicationUrl} 
              ApiURL={Vas.ApiUrl} 
              ApiKey={Vas.ApiKey}
              LabelPage={Vas.Resources.Labels["Page"]} 
              LabelOf={Vas.Resources.Labels["Of"]} 
              LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
              NewApi={true}
                />
          </div> 
        );
    }
}
export default Accounts;
